// extracted by mini-css-extract-plugin
export var button = "_bz-0";
export var icon = "_bz-1";